import { createSelector } from 'reselect';
import { AppState } from 'pages/app/state';
import { currentOperationSelector } from 'components/menu/selectors';
import { compareScanDatetime } from 'helpers/date-helper';
import { Guid } from 'types/guid';

const getOperationItems = (state: AppState) => state.operationGrid.items;

const isCurrentClientTransationId = (state: AppState, clientTransactionId: Guid) =>
  state.operationGrid.selectedClientTransactionId === clientTransactionId;

export const isActiveRow = createSelector(
  isCurrentClientTransationId,
  (isActive) => {
    return isActive;
  }
);

export const getCurrentClientTransactionIds = createSelector(
  [currentOperationSelector, getOperationItems],
  (currentOperation, items) => {
    return items.filter(i => i.operation === currentOperation.nmvsOperation).sort(compareScanDatetime).map(i => i.clientTransactionId);
  }
);



// WEBPACK FOOTER //
// ./src/components/operation-grid/selectors.ts